"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.Arrow = exports.SquareDonut = exports.Cross = exports.Star = exports.Polygon = exports.PolygonCard = exports.Diamond = exports.CircleGrid = exports.Circle = exports.Donut = void 0;
var donut_1 = require("./shapes/donut");
__createBinding(exports, donut_1, "Donut");
var circle_1 = require("./shapes/circle");
__createBinding(exports, circle_1, "Circle");
var circlegrid_1 = require("./shapes/circlegrid");
__createBinding(exports, circlegrid_1, "CircleGrid");
var diamond_1 = require("./shapes/diamond");
__createBinding(exports, diamond_1, "Diamond");
var polygonCard_1 = require("./shapes/polygonCard");
__createBinding(exports, polygonCard_1, "PolygonCard");
var polygon_1 = require("./shapes/polygon");
__createBinding(exports, polygon_1, "Polygon");
var star_1 = require("./shapes/star");
__createBinding(exports, star_1, "Star");
var cross_1 = require("./shapes/cross");
__createBinding(exports, cross_1, "Cross");
var squareDonut_1 = require("./shapes/squareDonut");
__createBinding(exports, squareDonut_1, "SquareDonut");
var arrow_1 = require("./shapes/arrow");
__createBinding(exports, arrow_1, "Arrow");
